import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import Button from 'antd/es/button';
import { styled, useTheme } from 'styled-components';

type SideBarFooterProps = {
  toggleCollapsed: () => void;
  isCollapsed: boolean;
};

const StyledSideBarFooter = styled.div`
  ${({ theme }) => `
  height: ${theme.controlHeightLG}px;
  background: ${theme.colorBgContainer};
  border-top: ${theme.lineWidth}px ${theme.lineType} ${theme.colorBorder};

  @container app (width < ${theme.screenMD}px) {
    display: none;
  }
`}
`;

const CollapseButton = styled(Button)`
  height: 100%;
  width: 100% !important;
  border-radius: 0;
`;

export const SideBarFooter = ({
  toggleCollapsed,
  isCollapsed,
}: SideBarFooterProps) => {
  const theme = useTheme();

  return (
    <StyledSideBarFooter>
      <CollapseButton
        type="text"
        icon={
          <MenuFoldOutlined
            style={{
              transform: isCollapsed ? 'rotateY(180deg)' : 'rotateY(0deg)',
              transition: `transform ${theme.motionDurationMid} ease-in-out`,
            }}
          />
        }
        onClick={toggleCollapsed}
      />
    </StyledSideBarFooter>
  );
};
